import { compose } from 'redux';

import {
  MAX_FILE_UPLOAD_SIZE,
  ACCEPT_IMAGE_CONTENT_TYPES,
} from '../../../constants';

const createValidation = (fn, error) => (
  data = { input: undefined, errors: [] },
) => {
  if (!fn(data.input)) {
    data.errors.push(error);
  }
  return data;
};

const validateImageType = createValidation(
  file => file && ACCEPT_IMAGE_CONTENT_TYPES.includes(file.type.toLowerCase()),
  'allowedImageTypes',
);

const validateImageSize = createValidation(
  file => file && MAX_FILE_UPLOAD_SIZE > file.size,
  'allowedImageSize',
);

export const validateImage = file =>
  compose(validateImageSize, validateImageType)({ input: file, errors: [] });

export const getDataURLFromFile = async file =>
  new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onerror = reject;
    fr.onloadend = () => {
      const url = fr.result;
      const data = url.substr(url.indexOf(',') + 1);
      resolve({
        data,
        url,
      });
    };
    fr.readAsDataURL(file);
  });

export const getDataURLFromImage = async path => {
  const resp = await fetch(path);
  const blob = await resp.blob();
  const { data } = await getDataURLFromFile(blob);
  return data;
};

export const getBase64ImageUrl = (canvas, img) => {
  /* eslint-disable no-param-reassign */
  canvas.width = img.width;
  canvas.height = img.height;
  canvas.getContext('2d').drawImage(img, 0, 0);

  return canvas
    .toDataURL('image/png')
    .replace(/^data:image\/(png|jpg);base64,/, '');
};
